import React from "react";
import { Alert } from "react-bootstrap";

import { GroupCards } from "./GroupCards";

/**
 * True when a 200 response is all-default: every member is tier "target" with
 * band 2 (the engine's no-matching-assessments fallback). Drives the non-error
 * all-default banner. An empty-groups response is NOT all-default.
 */
export const isAllDefaultBand2 = (response) => {
  const groups = response?.groups || [];
  const members = groups.flatMap((g) => g.members || []);
  if (members.length === 0) return false;
  return members.every((m) => m.tier === "target" && m.band === 2);
};

const ALL_DEFAULT_NOTE =
  "These groups are all-default because no matching assessments were found.";

/**
 * Turn a grouping outcome (a GroupRecommendationResponse OR an error carrying
 * .status/.detail) into an explicit panel — never a crash (Group F).
 *
 *  - 404 ClassroomNotFound -> "Classroom not found" error panel
 *  - 422 -> validation-error panel
 *  - 200 groups [] -> "No active students in this classroom"
 *  - 200 all-default Band-2 -> non-error all-default banner + tier cards
 *  - 200 normal -> tier cards
 */
export const SimulationResult = ({ response, error }) => {
  if (error) {
    if (error.status === 404) {
      return (
        <Alert variant="danger" data-testid="not-found-panel">
          Classroom not found
        </Alert>
      );
    }
    return (
      <Alert variant="danger" data-testid="validation-error-panel">
        Validation error: {error.detail || "the request was invalid"}
      </Alert>
    );
  }

  if (!response) return null;

  const groups = response.groups || [];
  if (groups.length === 0) {
    return (
      <Alert variant="info" data-testid="no-active-students-panel">
        No active students in this classroom
      </Alert>
    );
  }

  return (
    <div className="simulation-result">
      {isAllDefaultBand2(response) && (
        <Alert variant="warning" data-testid="all-default-banner">
          {ALL_DEFAULT_NOTE}
        </Alert>
      )}
      <GroupCards response={response} />
    </div>
  );
};
